/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="19"
        height="18"
        viewBox="0 0 19 18"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M0 18h19V6H0Zm1.56-1.12 4.28-5.19 3.67 3.11 3.66-3.1 4.27 5.18Zm16.44-.9-4.07-4.93L18 7.58Zm-.86-9L9.51 13.5 1.86 7.01ZM1 7.56l4.08 3.46L1 15.96Zm9.59-7.58H3v9h13V5.2L10.65.04ZM4 8.98v-8h6v4.9h5v3.1Zm12-3v1H4v-1Zm-5-4 3.21 3.2H11Z"
          className="icon-fill"/>
      </svg>
    );
  }
}

Icon.displayName = 'EnvelopeWithPaperFoldedCornerIcon';

export default Icon;
